import React, { useState } from 'react';
import { PencilIcon, TrashIcon, PlusIcon, SparklesIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
export function TaskUnderstandingScreen({
  data,
  updateData,
  onNext
}: ScreenProps) {
  const [steps, setSteps] = useState<string[]>(data.jobSteps);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editValue, setEditValue] = useState('');
  const handleRemove = (index: number) => {
    const newSteps = steps.filter((_, i) => i !== index);
    setSteps(newSteps);
    updateData({
      jobSteps: newSteps
    });
  };
  const handleEditStart = (index: number, value: string) => {
    setEditingIndex(index);
    setEditValue(value);
  };
  const handleEditSave = (index: number) => {
    const newSteps = [...steps];
    newSteps[index] = editValue;
    setSteps(newSteps);
    updateData({
      jobSteps: newSteps
    });
    setEditingIndex(null);
  };
  const handleAddStep = () => {
    const newSteps = [...steps, 'New step'];
    setSteps(newSteps);
    updateData({
      jobSteps: newSteps
    });
    setEditingIndex(newSteps.length - 1);
    setEditValue('New step');
  };
  return <div className="flex flex-col h-full" data-id="element-1022">
      <div className="mb-6" data-id="element-1023">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-1024">
          Detected Work Scope
        </h2>

        <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-lg p-3 flex items-start gap-3 mb-6" data-id="element-1025">
          <SparklesIcon className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0" data-id="element-1026" />
          <p className="text-sm text-yellow-200" data-id="element-1027">
            The system identified the following task:
          </p>
        </div>

        <div className="bg-slate-900 border border-slate-700 rounded-xl p-4 border-l-4 border-l-yellow-500" data-id="element-1028">
          <h3 className="text-white font-bold text-lg" data-id="element-1029">
            Steel Beam Installation Using Mobile Crane
          </h3>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto pb-20 -mx-4 px-4" data-id="element-1030">
        <p className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-4" data-id="element-1031">
          Suggested Job Steps
        </p>

        <div className="space-y-3" data-id="element-1032">
          <AnimatePresence data-id="element-1033">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            delay: index * 0.05
          }} className="bg-slate-900 border border-slate-800 rounded-lg p-3 flex items-center gap-3" data-id="element-1034">
                <div className="w-6 h-6 rounded-full bg-slate-800 text-slate-400 flex items-center justify-center text-xs font-bold flex-shrink-0" data-id="element-1035">
                  {index + 1}
                </div>

                {editingIndex === index ? <input autoFocus value={editValue} onChange={e => setEditValue(e.target.value)} onBlur={() => handleEditSave(index)} onKeyDown={e => e.key === 'Enter' && handleEditSave(index)} className="flex-1 bg-slate-950 border border-yellow-500 rounded px-2 py-1 text-white text-sm outline-none" data-id="element-1036" /> : <p className="flex-1 text-slate-200 text-sm leading-snug" data-id="element-1037">
                    {step}
                  </p>}

                <div className="flex items-center gap-1 flex-shrink-0" data-id="element-1038">
                  <button onClick={() => handleEditStart(index, step)} className="p-2 text-slate-500 hover:text-yellow-400 transition-colors" data-id="element-1039">
                    <PencilIcon className="w-4 h-4" data-id="element-1040" />
                  </button>
                  <button onClick={() => handleRemove(index)} className="p-2 text-slate-500 hover:text-red-400 transition-colors" data-id="element-1041">
                    <TrashIcon className="w-4 h-4" data-id="element-1042" />
                  </button>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>

        <motion.button whileTap={{
        scale: 0.98
      }} onClick={handleAddStep} className="mt-4 w-full py-3 border-2 border-dashed border-slate-700 rounded-lg text-slate-400 font-medium text-sm flex items-center justify-center gap-2 hover:border-slate-500 hover:text-slate-300 transition-colors" data-id="element-1043">
          <PlusIcon className="w-4 h-4" data-id="element-1044" />
          Add Step
        </motion.button>
      </div>

      <div className="pt-4 bg-slate-950" data-id="element-1045">
        <PrimaryButton onClick={onNext} data-id="element-1046">Confirm Steps</PrimaryButton>
      </div>
    </div>;
}